<script>
import api from "@services/api";
export default {
  name: "abc",
  components: {},
  props: {
    table: {
      type: String,
      default: "Chamado"
    },
    closeModalChamado: {
      type: Function
    },
    chamadoId: {
      type: Number
    },
    editMode: {
      type: Boolean
    }
  },
  data: function() {
    return {
      name: "file",
      projetoList: [],
      arquivoList: [],
      usuarioList: [],
      chamadoPrioridadeList: [],
      item: {
        ChamadoArquivo: [],
        id: undefined,
        etapaFluxo: { id: undefined },
        ordem: 1
      },
      files: [],
      showFileModal: false,
      data: {
        _csrf_token: "xxxxxx"
      },
      thread: 3,
      disabeEdit: false,
      projetoId: null,
      usuarioId: null,
      chamadoFluxoList: []
    };
  },
  created() {
    this.getListProjetos();
    this.getListChamadoPrioridade();
    this.getEtapasFluxo();
    if (this.editMode) {
      this.disabeEdit = true;
      this.get();
      // aberto
    } else {
      this.item.etapaFluxoId = 1;
    }
  },
  methods: {
    getListUsuariosProjeto() {
      api.get(`api/Atendimento/projetos`).then(response => {
        this.projetoList = response.data["data"];
      });
      if (this.projetoId) {
        api
          .get(`api/Chamado/GetUsuariosProjeto`, {
            params: {
              projetoId: this.projetoId
            }
          })
          .then(response => {
            this.usuarioList = response.data["data"];
          });
      }
    },
    getListProjetos() {
      api.get(`api/Atendimento/projetos`).then(response => {
        this.projetoList = response.data["data"];
      });
    },
    getListChamadoPrioridade() {
      api.get(`api/Atendimento/ChamadoPrioridade`).then(response => {
        this.chamadoPrioridadeList = response.data["data"];
      });
    },
    save() {
      if (this.item.id) {
        api.put(`api/Chamado`, this.item).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.hasSuccess = true;
            this.closeModalChamado();
          } else {
            throw response;
          }
        });
      } else {
        let formData = new FormData();
        formData.append("chamado", JSON.stringify(this.item));
        formData.append("arquivo", this.arquivoList[0]);
        api.post(`api/Chamado/InsertWhithFile`, formData).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.hasSuccess = true;
            this.closeModalChamado();
          } else {
            throw response;
          }
        });
      }
    },
    get() {
      api.get(`api/chamado/${this.chamadoId}`).then(response => {
        this.item = response.data["data"];
        this.projetoId = this.item.projetoId;
      });
    },
    getEtapasFluxo() {
      api.get(`api/Chamado/GetEtapasFluxoChamado`).then(response => {
        this.chamadoFluxoList = response.data["data"];
      });
    },
    listFluxo() {
      if (this.editMode) {
        return [
          {
            denominacao: this.item.etapaFluxo.denominacao,
            etapaFluxoId: this.item.etapaFluxo.id
          }
        ];
      } else {
        return [{ denominacao: "Solicitação", id: 1, etapaFluxoId: 1 }];
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    projetoListComp() {
      return this.projetoList.map(p => ({
        id: p.id,
        denominacao: p.cliente + " - " + p.descricao
      }));
    },
    chamadoPrioridadeComp() {
      return this.chamadoPrioridadeList
        .filter(p => p.tipo == (this.item.incidente == 1 ? "I" : "C"))
        .map(p => ({
          id: p.id,
          denominacao: p.denominacao
        }));
    }
  },
  watch: {
    projetoId: function() {
      this.item.projetoId = this.projetoId;
      this.getListUsuariosProjeto();
    },
    "item.chamadoPrioridadeId": function() {
      if (!this.editMode) {
        var obj = {
          projetoId: this.item.projetoId,
          ChamadoPrioridadeId: this.item.chamadoPrioridadeId
        };
        api
          .get(`api/Chamado/GetChamadoOrdem`, {
            params: obj
          })
          .then(response => {
            this.item.ordem = response.data["data"];
          });
      }
    }
  }
};
</script>
<template>
  <div>
    <b-form class="p-2" ref="form" @submit.prevent="save">
      <b-form-group id="input-group-1" label="Projeto" label-for="projetoId">
        <b-form-select id="ProjetoId" v-model="projetoId" required>
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in projetoListComp"
            :key="option.id"
            :value="option.id"
          >
            {{ option.denominacao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-1"
        label="Solicitante"
        label-for="usuarioId"
        v-if="user.perfil != 'Cliente'"
      >
        <b-form-select id="UsuarioId" v-model="item.usuarioId" required>
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in usuarioList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.nome }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-row>
        <b-col class="col-md-2">
          <b-form-checkbox
            v-model="item.incidente"
            class="mt-4"
            :disabled="editMode"
            >Incidente</b-form-checkbox
          >
        </b-col>
        <b-col class="col-md-3">
          <b-form-group
            id="input-group-122"
            label="Prioridade"
            label-for="projetoId"
          >
            <b-form-select
              id="ChamadoPrioridadeId"
              v-model="item.chamadoPrioridadeId"
              required
            >
              <b-form-select-option disabled :value="undefined"
                >Selecione um item da lista</b-form-select-option
              >
              <b-form-select-option
                v-for="option in chamadoPrioridadeComp"
                :key="option.id"
                :value="option.id"
              >
                {{ option.denominacao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col class="col-md-1">
          <b-form-group
            id="input-group-3"
            label="Ordem"
            label-for="ordemChamado"
          >
            <b-form-input
              id="ordemChamado"
              type="number"
              required
              v-model="item.ordem"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-122"
            label="Status"
            label-for="projetoId"
          >
            <b-form-select
              id="ChamadoFluxoId"
              v-model="item.etapaFluxoId"
              :disabled="true"
            >
              <b-form-select-option disabled :value="undefined"
                >Selecione um item da lista</b-form-select-option
              >
              <b-form-select-option
                v-for="option in listFluxo(item.etapaFluxo.id)"
                :key="option.etapaFluxoId"
                :value="option.etapaFluxoId"
              >
                {{ option.denominacao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-3"
            label="Carga Horária"
            label-for="CargaHoraria"
          >
            <b-form-input
              id="cargaHoraria"
              type="number"
              min="0"
              v-model="item.cargaHoraria"
              :disabled="
                user.perfil == 'Cliente' ||
                  user.perfil == 'Cliente-Administrador'
              "
            />
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-group id="input-group-4" label="Assunto" label-for="Assunto">
        <b-form-input
          id="assuntoChamado"
          type="text"
          required
          v-model="item.assunto"
        />
      </b-form-group>

      <b-form-group id="input-group-5" label="Descrição" label-for="descricao">
        <b-form-textarea
          id="textarea-large"
          rows="3"
          max-rows="5"
          no-resize
          v-model="item.descricao"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group id="button-group" class="mt-4">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>
    </b-form>
  </div>
</template>
